import duck from '../../core/conversations';

const conversations = duck({});

export const { operations } = conversations;
export const { selectors } = conversations;
export default conversations;
